import PropTypes from 'prop-types'

import LocationCard from './LocationCard'

function MapInfoWindow({ location }) {
  return (
    <div className="map-info-window">
      <LocationCard location={location} />
    </div>
  )
}
MapInfoWindow.propTypes = {
  location: PropTypes.oneOfType([PropTypes.object]).isRequired,
}

export default MapInfoWindow
